import React from 'react';

// Two interlocking rings — two ideas fused into one product.
export function LogoMark({ className = 'size-8' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="mfi-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3355FF" />
          <stop offset="1" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="#0A0F1F" />
      <circle cx="26" cy="32" r="13" fill="none" stroke="url(#mfi-g)" strokeWidth="5" />
      <circle cx="38" cy="32" r="13" fill="none" stroke="#fff" strokeOpacity=".9" strokeWidth="5" />
    </svg>
  );
}

export default function Logo({ inverted = false }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark />
      <span className={`font-display text-[1.05rem] font-semibold leading-none tracking-[-0.02em] ${inverted ? 'text-white' : 'text-ink'}`}>
        Market Fusion
        <span className={`block text-[0.68rem] font-medium uppercase tracking-[0.22em] ${inverted ? 'text-white/60' : 'text-ink-3'}`}>
          Innovations
        </span>
      </span>
    </span>
  );
}
